import { Swiper } from "@theme/swiper";
import { events, subscribe } from "@theme/event-bus";

const MOBILE = "(max-width: 1023px)";

/**
 * @param {HTMLElement} wrap
 */
function destroyGallerySwiper(wrap) {
  const el = wrap.querySelector(".product-gallery.swiper");
  if (el?.swiper) {
    el.swiper.destroy(true, true);
  }
}

/**
 * @param {HTMLElement} wrap
 */
function initGallerySwiper(wrap) {
  if (!window.matchMedia(MOBILE).matches) return;

  const el = wrap.querySelector(".product-gallery.swiper");
  if (!el || el.swiper) return;

  const slides = el.querySelectorAll(".swiper-slide");
  if (slides.length < 2) return;

  new Swiper(el, {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: el.querySelector(".product-gallery__pagination"),
      clickable: true,
    },
  });
}

function syncAllGalleries() {
  document.querySelectorAll(".product-gallery-wrap").forEach((wrap) => {
    destroyGallerySwiper(wrap);
    initGallerySwiper(wrap);
  });
}

function bootGallerySwipers() {
  syncAllGalleries();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootGallerySwipers);
} else {
  bootGallerySwipers();
}

window.matchMedia(MOBILE).addEventListener("change", () => {
  syncAllGalleries();
});

subscribe(events.sectionUpdate, () => {
  requestAnimationFrame(() => syncAllGalleries());
});
